import { FormControl, Grid, TextField, WithStyles } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import * as React from "react";
import { styles } from "./SAPForm.styles";
import { BlueButton } from "../../Buttons/BlueButton";
import UserDetailsModel from "../../../../models/user/UserDetailsModel";
import { useTranslation } from "react-i18next";
import { isPermissionGranted } from "../../../../utilities/permissionUtils";
import { useGetRoles } from "../../../../hooks/useGetRole";
import { useState } from "react";
import { useSelector } from "react-redux";
import Autocomplete from "@material-ui/lab/Autocomplete/Autocomplete";
import BusinessPartnerModel from "../../../../models/businessPartner/BusinessPartnerModel";
import { useHistory } from "react-router-dom";

export interface ISAPFormProps extends WithStyles<typeof styles> {
    userDetails: UserDetailsModel;
    onSave: any;
}

const SAPFormPure: React.FunctionComponent<ISAPFormProps> = ({ onSave, userDetails, classes }: ISAPFormProps) => {
    const history = useHistory();

    const businessPartnersFromState = useSelector(state => state.businessPartners);   

    let allBusinessPartners;
    if (businessPartnersFromState) {
        allBusinessPartners = Object.values(businessPartnersFromState)?.map((bp: BusinessPartnerModel) => ({
            bpId: bp.bpId,
            bpName: bp.bpName
        }));
    }

    const [details, setDetails] = useState({
        bpId: userDetails.bpId,
        bpName: userDetails.bpName
    });

    const handleBpChange = bp => {
        setDetails({
            ...details,
            bpId: bp?.bpId,
            bpName: bp?.bpName
        });
    };

    const handleRedirect = () => {
        history.push("/admin/business-partners");
    };

    const handleSave = () => {
        userDetails.bpId = details.bpId;
        userDetails.bpName = details.bpName;

        onSave(userDetails);
    };

    const { t } = useTranslation();
    const isDisabled = !isPermissionGranted(useGetRoles(), "users.write");

    return allBusinessPartners ? (
        <>
            <Grid container spacing={0}>
                <Grid item xs={6} md={6}>
                    <FormControl variant="outlined" className={classes.formControl}>
                        <Autocomplete
                            id="sapBPId"
                            options={allBusinessPartners}
                            getOptionLabel={(option: any) => String(option.bpId) + " - " + option.bpName}
                            value={allBusinessPartners.find(bp => String(bp.bpId) === String(details.bpId))}
                            renderInput={params => <TextField
                                {...params}
                                multiline
                                variant="outlined"
                                label="SAP BP-ID and SAP BP-Name "
                                />}
                            renderOption={(option: any) => (
                                <React.Fragment>
                                    {`${option.bpId} - ${option.bpName}`}
                                </React.Fragment>
                            )}
                            onChange={(event, bp) => handleBpChange(bp)}
                            getOptionSelected={(option, value) => String(option.bpId) === String(value.bpId)}
                            disabled={isDisabled}
                            disableClearable={true}
                        />
                    </FormControl>
                </Grid>
                <Grid item xs={6} md={6} className={classes.redirectButton}>
                    <BlueButton
                        onClick={handleRedirect}
                    >Add or edit BP-ID and BP-Name</BlueButton>
                </Grid>
            </Grid>
            <Grid container spacing={3}>
                <Grid item xs={12} sm={12}>
                    <BlueButton onClick={handleSave} disabled={isDisabled}>
                        {t("general.save")}
                    </BlueButton>
                </Grid>
            </Grid>
        </>
    ) : null;
};

export const SAPForm = withStyles(styles)(SAPFormPure);
